import { updateConfirmModalDisplay } from '@/features/modalSlice';
import { IConfirmModalProps } from '@/ts/common-types';
import { Modal } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ExclamationCircleFilled } from '@ant-design/icons';

const ConfirmModal: React.FC<IConfirmModalProps> = ({ modalData }) => {
    const dispatch = useDispatch();


    useEffect(() => {
        if (!modalData.value) return;

        let isLoading = false;

        const modalInstance = Modal.confirm({
            icon: <ExclamationCircleFilled />,
            title: modalData.title || 'Confirm Action',
            content: modalData.message || 'Description',
            okText: 'Yes',
            cancelText: 'Cancel',
            centered: true,
            className: 'custom-confirm-modal',
            okButtonProps: {
                loading: false,
            },
            onOk: async () => {
                if (isLoading) return;
                isLoading = true;

                modalInstance.update({
                    okButtonProps: { loading: true },
                });

                try {
                    if (modalData.onConfirm) {
                        await modalData.onConfirm();
                    }
                } finally {
                    isLoading = false;
                    modalInstance.destroy();
                    dispatch(updateConfirmModalDisplay({
                        value: false,
                        title: "",
                        message: "",
                    }));
                }
            },
            onCancel: () => {
                dispatch(updateConfirmModalDisplay({
                    value: false,
                    title: "",
                    message: "",
                }));
            },
        });

    }, [modalData, dispatch]);

    return null;
};

export default ConfirmModal